import { Grid, Typography } from '@mui/material';
import React from 'react'
import styles from '../../../../../../../assets/styles/componentStyles/templatemessages.module.scss'

interface templateBodyPreview {
    bodyText: string,
    isCarouselTemplate?: boolean,
}

function TemplateBodyPreview(props: templateBodyPreview) {
    const { bodyText } = props;
    
    return (
        <>
            <Grid item className={styles.templatePrviewBodyItem} dir="auto">
                <pre
                    className={styles.preTextStyle}
                    dangerouslySetInnerHTML={{ __html: bodyText }}
                />
            </Grid>
        </>
    )
}

export default TemplateBodyPreview